import {
  addLeadingZeroesToZip,
  downcaseEmail,
  standardizeFullName,
} from "../hooks"
import { addressFields, contactFields, getBoatFields } from "./shared"

export const getCustomerImportConfig = ({ boatTypes }) => {
  // supercede the `boat_name`, `measurement_unit` and `length_overall`
  // shared fields with fields that require either all 3 to be empty
  // OR have a value since unlike the contracts import we *do* want
  // to allow a customer to be imported without a boat, but want
  // at minumum these 3 fields to create it.
  const baseBoatFields = getBoatFields(boatTypes)
  const boatFieldsWithOverrides = {
    ...baseBoatFields,
    boatName: {
      ...baseBoatFields.boatName,
      validators: [
        {
          validate: "require_with",
          fields: ["length_overall", "measurement_unit"],
          errorMessage:
            "Boat name, LOA, and measurement unit must all be provided together or all left blank",
        },
      ],
    },
    measurementUnit: {
      ...baseBoatFields.measurementUnit,
      validators: [
        {
          validate: "require_with",
          fields: ["boat_name", "length_overall"],
          errorMessage:
            "Boat name, LOA, and measurement unit must all be provided together or all left blank",
        },
      ],
    },
    lengthOverall: {
      ...baseBoatFields.lengthOverall,
      validators: [
        {
          validate: "require_with",
          fields: ["boat_name", "measurement_unit"],
          errorMessage:
            "Boat name, LOA, and measurement unit must all be provided together or all left blank",
        },
      ],
    },
  }
  const fields = [
    ...Object.values(contactFields),
    ...Object.values(addressFields),
    ...Object.values(boatFieldsWithOverrides),
  ]

  const columnHooks = [
    { fieldName: "name", callback: standardizeFullName },
    { fieldName: "zip", callback: addLeadingZeroesToZip },
  ]

  const rowHooks = [downcaseEmail]

  return { fields, columnHooks, rowHooks }
}
